import { useState, useEffect, useCallback } from 'react'
import { apiService } from '../services/api'

export const useProducts = (initialParams = {}) => {
  const [products, setProducts] = useState([])
  const [pagination, setPagination] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
    ...initialParams
  })

  const fetchProducts = useCallback(async (newParams = {}) => {
    setLoading(true)
    setError(null)
    try {
      const finalParams = { ...params, ...newParams }
      const response = await apiService.getProducts(finalParams)
      setProducts(response.products)
      setPagination(response.pagination)
      setParams(finalParams)
    } catch (err) {
      setError(err.message)
      console.error('Error fetching products:', err)
    } finally {
      setLoading(false)
    }
  }, [params])

  useEffect(() => {
    fetchProducts(initialParams)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadMore = useCallback(() => {
    if (pagination.hasNextPage && !loading) {
      fetchProducts({ page: pagination.currentPage + 1 })
    }
  }, [pagination, loading, fetchProducts])

  const search = useCallback((searchTerm, filters = {}) => {
    fetchProducts({ 
      page: 1, 
      search: searchTerm, 
      ...filters 
    })
  }, [fetchProducts])

  const applyFilters = useCallback((filters) => {
    fetchProducts({ page: 1, ...filters })
  }, [fetchProducts])

  return {
    products,
    pagination,
    loading,
    error,
    params,
    fetchProducts,
    loadMore,
    search,
    applyFilters
  }
}